import * as d3 from 'd3';

import { AggregationMode } from '../../models';

export interface IAggregationHelper {
    aggregate(values: { value: number }[], mode: AggregationMode): number;
}

export class AggregationHelper implements IAggregationHelper {
    static serviceId: string = 'aggregationHelper';
    static $inject = [];

    aggregate(values: { value: number }[], mode: AggregationMode): number {
        let result = NaN;
        const hasValues = values && values.length > 1;
        if (hasValues) {
            switch (mode) {
                case AggregationMode.Average:
                    result = d3.mean(values, v => v.value);
                    break;
                case AggregationMode.Sum:
                    result = d3.sum(values, v => v.value);
                    break;
                case AggregationMode.Minimum:
                    result = d3.min(values, v => v.value);
                    break;
                case AggregationMode.Maximum:
                    result = d3.max(values, v => v.value);
                    break;
                case AggregationMode.First:
                    result = (values && values.length > 0) ? values[0].value : undefined;
                    break;
                case AggregationMode.Last:
                    result = (values && values.length > 0) ? values.reverse()[0].value : undefined;
                    break;
                case AggregationMode.StdDev:
                    result = d3.variance(values, v => v.value);
                    break;
                case AggregationMode.Delta:
                    try {
                        const first = values[0];
                        const last = values.reverse()[0];
                        result = last.value - first.value;
                    } catch (e) {
                        console.error(e);
                    }
                    break;
            }
        }
        return result;
    }

}
